import React from "react";
import {Image} from 'react-bootstrap';

import bienvenidosImg from '../../Resources/Images/SVG/bienvenidos.svg'
import adorno from '../../Resources/Images/SVG/adorno.svg'
import imageCol1 from '../../Resources/Images/SVG/boda1.svg'
import imageCol2 from '../../Resources/Images/SVG/boda2.svg'
import imageCol3 from '../../Resources/Images/SVG/boda3.svg'
import imageCol4 from '../../Resources/Images/SVG/boda4.svg'
import imageCol5 from '../../Resources/Images/SVG/boda5.svg'
import imageCol01 from '../../Resources/Images/SVG/regalo1.svg'
import imageCol02 from '../../Resources/Images/SVG/regalo2.svg'
import imageCol03 from '../../Resources/Images/SVG/regalo3.svg'
import imageCol04 from '../../Resources/Images/SVG/regalo4.svg'
import imageCol05 from '../../Resources/Images/SVG/regalo5.svg'

function NiContent () {
    return (
        <div>
            {/* Benficios Club de bodas */}
            <div className="d-flex flex-column justify-content-center align-items-center pb-4">
                <Image className="clubes--img-bienvenidos" src={bienvenidosImg} fluid/>
                <p className="clubes--p-titulo"><strong>Beneficios Club Bodas</strong></p>
                <Image className="clubes--img-adorno " src={adorno} fluid/>
            </div>

            <div className="container">
                <div className="row row-cols-1 row-cols-sm-2 row-cols-md-4">
                    
                    <div className="col clubes--beneficios-p m-0 p-2">
                        <div className="clubes--beneficios-img-container pt-4 pb-4">
                            <Image className="pb-3 clubes--beneficios-img-1" src={imageCol1} fluid/>
                        </div>
                        <div className="d-flex">
                            <p className="clubes--beneficios-texto--num">1</p>
                            <p className="clubes--beneficios-texto pt-1"><b className="clubes--beneficios-texto--title-b">El Listado de Regalos para Boda</b> es completo, flexible y accesible para todos tus invitados:</p>
                        </div>
                        <ul className="clubes--beneficios-texto clubes--beneficios-list pl-4">
                            <li className="pb-4">Estará disponible en todas las tiendas de Almacenes SIMAN, en siman.com y en WhatsApp SIMAN.</li>
                            <li className="p-0 m-0">
                                <p className="pt-1 m-0">Puedes agregar distintas opciones de regalo a tu listado:</p>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Artículos de los departamentos seleccionados en todas nuestras tiendas.</p>
                                </div>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Abonos a Regalo Abierto.</p>
                                </div>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Certificados de Regalo Electrónico.</p>
                                </div>        
                            </li>
                        </ul>
                    </div>

                    <div className="col clubes--beneficios-p m-0 p-2">

                        <div className="d-flex pt-4">
                            <p className="clubes--beneficios-texto--num">2</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Cuponera Club Bodas SIMAN.</b></p>

                                <p>Al crear tu evento te regalamos una cuponera de descuentos especiales en departamentos seleccionados para todas las compras necesarias de los novios.
                                </p>
                            </div>
                        </div>

                        <div className="clubes--beneficios-img-container p-2">
                            <Image className="pt-3 pb-3 clubes--beneficios-img-2" src={imageCol2} fluid/>
                        </div>
                        <div className="d-flex pt-4">
                            <p className="clubes--beneficios-texto--num">3</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p  className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Cuponera con Aliados Proveedores.</b> </p> 
                                <p>Obtén también una cuponera con descuentos y servicios exclusivos con nuestros proveedores aliados al Club Bodas para ayudarte en la organización de tu boda.</p>
                            </div>
                        </div>

                        <div className="d-flex mt-1 pt-3">
                            <p className="clubes--beneficios-texto--num">4</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p  className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Certificado de Cash Back.</b></p>
                                <p>Al finalizar tu evento recibirás un certificado de Cash Back, equivalente al 10% de las compras en tu listado a precio regular y el 10% del monto acumulado de abono a regalo abierto. </p>
                            </div>
                        </div>

                    </div>

                    <div className="col clubes--beneficios-p m-0 p-2">
                        <div className="clubes--beneficios-img-container pt-4">
                            <Image className="pb-3 clubes--beneficios-img-3" src={imageCol3} fluid/>
                        </div>
                        <div className="d-flex p-3 mt-3">
                            <p className="clubes--beneficios-texto--num">5</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p  className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Noche de Boda Gratis.</b></p>
                                <p  className="p-0 m-0">Al acumular determinado monto en las compras de tu listado, recibirás la opción de obtener tu Noche de Boda Gratis en uno de nuestros hoteles aliados al club.</p>
                            </div>
                        </div>

                        <div className="d-flex p-3 mt-3">
                            <p className="clubes--beneficios-texto--num">6</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p  className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Envío a Domicilio Gratis.</b></p>
                                <p>Enviaremos los regalos de tu Boda, a la dirección de los dueños del evento.</p>
                            </div>
                        </div>

                        <div className="clubes--beneficios-img-container">
                            <Image className="pb-3 clubes--beneficios-img-4" src={imageCol4} fluid/>
                        </div>
                        
                    </div>

                    <div className="col clubes--beneficios-p m-0 p-2">
                        

                        <div className="d-flex pt-3">
                            <p className="clubes--beneficios-texto--num clubes--beneficios-texto--num-especial">7</p>
                            <p className="clubes--beneficios-texto pt-1"><b className="clubes--beneficios-texto--title-b">Obtén los Beneficios con tu tarjeta CREDISIMAN.</b></p>
                        </div>
                        <ul className="clubes--beneficios-texto--14 clubes--beneficios-texto--ul pl-4">
                            <li className="pb-1">
                                <p><b>CREDICASA:</b> por un monto mínimo de compra de $500.00 puedes adquirir tus artículos en plazos de 24,36 y 48 meses, a una tasa preferencial de 27.9% + IVA anual ó 2.29% + IVA mensual. </p>
                            </li>
                            <li className="pt-2">
                                <p><b>6 CREDICUOTAS sin Intereses:</b> por un monto mínimo de compra de $150.00 puedes adquirirlos en plazos de 6 meses a tasa 0%.</p>
                            </li>
                        </ul>
                        <div className="d-flex p-3 mt-4">
                            <p className="clubes--beneficios-texto--num">8</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p  className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Puedes realizar cambios de tus regalos </b></p>
                                <p>Tienes hasta 30 días después del cierre de tu evento para realizar cambios en los artículos que te regalen, en cualquiera de nuestras sucursales del país  donde te inscribiste.</p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            {/* Beneficios Club de regalos */}
           <div className="d-flex clubes--bg-regalos clubes--cols-regalos justify-content-between">

                <div className="clubes--beneficios-img-container-header clubes--beneficios-img-container-header-col">
                    <Image className="pb-3 clubes--beneficios-reg-img-1" src={imageCol01} fluid/>
                </div>

                <div className="d-flex col-title--regalos flex-column align-items-center justify-content-center pb-3 pt-3">
                    <p className="clubes--p-titulo"><strong>Beneficios Club de Regalos</strong></p>
                    <Image className="clubes--img-adorno " src={adorno} fluid/>
                </div>

                <div className="clubes--beneficios-img-container-header clubes--beneficios-img-container-header-col">
                    <Image className="pb-3 clubes--beneficios-reg-img-3" src={imageCol03} fluid/>
                </div>

           </div>

            <div className="container clubes--bg-regalos">
                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3">
                    <div className="col m-0 clubes--beneficios-p">

                        <div className="d-flex">
                            <p className="clubes--beneficios-texto--num">1</p>
                            <p className="clubes--beneficios-texto pt-1"><b className="clubes--beneficios-texto--title-b">El Listado de Regalos para Club de Regalos</b> es completo, flexible y accesible para todos tus invitados.</p>
                        </div>

                        <ul className="clubes--beneficios-texto clubes--beneficios-list pl-4">
                            <li className="pb-4">Estará disponible en todas las tiendas de Almacenes SIMAN, en siman.com y en WhatsApp SIMAN.</li>
                            <li className="p-0 m-0">
                                <p className="pt-1 m-0">Puedes agregar distintas opciones de regalo a tu listado:</p>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Artículos de los departamentos seleccionados en todas nuestras tiendas.</p>
                                </div>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Abonos a Regalo Abierto.</p>
                                </div>
                                <div className="d-flex p-0 m-0">
                                    <span className="pr-1">-</span><p className="p-0 m-0">Certificados de Regalo Electrónico.</p>
                                </div>        
                            </li>
                        </ul>
                        
                    </div>
                    <div className="col  m-0 clubes--beneficios-p">
                            <div className="d-flex pr-4">
                                <p className="clubes--beneficios-texto--num">2</p>
                                <div className="clubes--beneficios-texto pt-1">
                                    <p className="m-0 p-0"><b className="clubes--beneficios-texto--title-b">Cuponera Club de Regalos SIMAN:</b></p>
                                    <p>Al crear tu evento te regalamos una cuponera de descuentos especiales en departamentos seleccionados para todas las compras necesarias del evento.</p>
                                </div>

                            </div>

                            <div className="d-flex pr-4">
                                <p className="clubes--beneficios-texto--num">3</p>
                                <div className="clubes--beneficios-texto pt-1">
                                    <p className="m-0 p-0"><b className="clubes--beneficios-texto--title-b">Cuponera con Aliados Proveedores. </b></p>
                                    <p>Obtén también una cuponera con descuentos y servicios exclusivos con nuestros proveedores aliados al Club de Regalos para ayudarte en la organización de tu evento.</p>
                                </div>

                            </div>

                            <div className="d-flex pr-4">
                                <p className="clubes--beneficios-texto--num">4</p>
                                <div className="clubes--beneficios-texto pt-1">
                                    <p className="m-0 p-0"><b className="clubes--beneficios-texto--title-b">Certificado de Cash Back:</b></p>
                                    <p>Al finalizar tu evento recibirás un certificado de Cash Back, equivalente al 10% de las compras en tu listado a precio regular y el 10% del monto acumulado de abono a regalo abierto</p>
                                </div>
                            </div>

                    </div>
                    <div className="col m-0 clubes--beneficios-p">
                        
                        <div className="d-flex pr-4">
                            <p className="clubes--beneficios-texto--num">5</p>
                            <p className="clubes--beneficios-texto pt-1"><b className="clubes--beneficios-texto--title-b">Obtén los Beneficios con tu tarjeta CREDISIMAN:</b></p>
                        </div>

                        <ul className="clubes--beneficios-texto">
                            <li className=""><p><b>3 CREDICUOTAS sin Intereses,</b> por un monto mínimo de compra de $150.00  </p></li>
                        </ul>

                        <div className="d-flex pr-4 pt-3">
                            <p className="clubes--beneficios-texto--num">6</p>
                            <div className="clubes--beneficios-texto pt-1">
                                <p className="p-0 m-0"><b className="clubes--beneficios-texto--title-b">Puedes realizar cambios de tus Regalos.</b></p>
                                <p>Tienes hasta 30 días después del cierre de tu evento para realizar cambios en los artículos que te regalen, en cualquiera de nuestras sucursales del país  donde te inscribiste. </p>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NiContent;